import { type ReactNode } from "react";

type PublicPageTitleProps = {
  children: ReactNode;
  className?: string;
};

// Same size and weight as the home section titles, in the primary color of the inner pages
const PublicPageTitle = ({ children, className = "" }: PublicPageTitleProps) => (
  <h1 className={`text-center text-2xl sm:text-3xl font-bold sm:font-extrabold text-primary-600 ${className}`.trim()}>
    {children}
  </h1>
);

export default PublicPageTitle;
